export default __webpack_public_path__ + "static/media/aircraft-landing-gear-desc.edb335aa.png";